/* AdhocQueryDetailsViewComponent.js */

"use strict";
const _ = require("lodash");
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./AdhocQueryDetailsViewRenderer");
const PagingResultFeed = require("./PagingResultFeed");
const MatchCountColumn = require("./column_renderers/match_count/MatchCountComponent");
const QueryStatusColumn = require("./column_renderers/query_status/QueryStatusComponent");
const ActionColumn = require("./column_renderers/links/LinksComponent");
const DeviceTypeColumn = require("./column_renderers/device_type/DeviceTypeComponent");
const MessageColumn = require("./column_renderers/message/MessageComponent");

class AdhocQueryDetailsViewComponent extends EventEmitter {
    constructor(
        logger,
        gameEditor,
        userSession,
        LicenseRestriction,
        MUF,
        solutionsManager,
        storageFactory,
        steveIo,
        DeviceEntity,
        ConstructInstanceEntity,
        JobEntity,
        ControlUserEntity,
        AdHocQuery,
        AdHocQueryExecution,
        AdHocQueryResult,
        CommandSetEntity
    ) {
        super();
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._modalUserFeedback = MUF;
        this._steveIo = steveIo;
        this._CommandSetEntityDef = CommandSetEntity;

        this._deviceEntityDef = DeviceEntity;
        this._constructInstanceEntityDef = ConstructInstanceEntity;
        this._ControlUserEntityDef = ControlUserEntity;

        this._controlUser = undefined;

        this._adHocQueryEntityDef = AdHocQuery;
        this._adHocQueryExecutionEntityDef = AdHocQueryExecution;
        this._adHocQueryExecutionEntity = {};
        this._adHocQueriesMap = {};
        this._lastAdHocEntityId = "";
        this._lastAdHocResult = undefined;
        this._lastRunExecution = {};
        this._preSelect = "";
        this._adHocQueryResultEntitiesDef = AdHocQueryResult;
        this._adHocQueryResultEntities = undefined;
        this._proxyAdHocQueryEntity = {};
        this._valuesToCopyToProxy = {};
        this._proxyExecutionEntity = {};
        this._adHocRun = false;
        this._lastRunSelected = false;
        this._adHocQueryExecutionEntityGen = {};
        this._adHocQueryResultEntitiesGen = {};
        this._selectedResults = [];
        this._noDevicesSelected = false;

        this.adHocQueryDropdownList = [];

        this._dirty = false;

        this._device = undefined;

        this._userSession = userSession;
        this._licenseRestriction = LicenseRestriction;
        this._storageFactory = storageFactory;
        this._isCDSolutionAvailable = this._hasAccessToCDA();

        this._selectedDevices = this._gameEditor._selectedDevice;
        this._toggleMode = true;
        this._jobEntityDef = JobEntity;
        this._newCreated = false;
        this._justSaved = false;
        this._executionId = null;

        this._matchCount = {};
        // TODO Quick hack to customize DeviceDetailsView based on its parent solution (Device Manager or Config Drift)
        // To be refactored with separate views once form layout / style specifications have matured
        this._solutionDefinition = solutionsManager.getActiveSolution();
        this._solutionName = this._solutionDefinition.name || "";
        this._results = undefined;

        this._gridKey = "device_grid_AdHoc";
        let typeBaseGroupMap = _.get(this._deviceEntityDef, "typeBaseGroupMap");
        let optionFilterList = {};
        _.sortBy(Object.keys(typeBaseGroupMap)).map(function (key) {
            optionFilterList[key] = {name: key, title: key};
        });

        this.columnsResult = {
            id: {
                label: "id",
                shown: false,
                width: 450,
                priority: 10,
                sortable: false,
            },
            jobIds: {
                label: "id",
                shown: false,
                width: 450,
                priority: 10,
                sortable: false,
            },
            deviceDetectedTypeBase: {
                label: "Type",
                columnRendererComponent: DeviceTypeColumn,
                entityColumn: true,
                width: 45,
                context: {
                    adhocDetails: this,
                },
                resizable: false,
                priority: 1,
                groupable: true,
                shown: true,
            },
            deviceName: {
                label: "Name",
                width: 220,
                shown: true,
                priority: 2,
            },
            deviceDescription: {
                label: "Description",
                shown: true,
                width: 300,
                priority: 3,
            },
            deviceIp: {
                label: "IP Address",
                shown: true,
                width: 140,
                priority: 4,
            },
            deviceDetectedVendor: {
                label: "Vendor",
                groupable: true,
                shown: true,
                priority: 5,
                width: 140,
            },
            deviceDetectedSerialNumber: {
                label: "Serial",
                shown: true,
                groupable: true,
                width: 140,
                priority: 6,
            },
            matchCount: {
                label: "Match Count",
                shown: true,
                width: 140,
                priority: 7,
                entityColumn: true,
                columnRendererComponent: MatchCountColumn,
                sortable: true,
                context: {
                    adhocDetails: this,
                },
            },
            status: {
                label: "Query Status",
                shown: true,
                width: 110,
                priority: 8,
                entityColumn: true,
                columnRendererComponent: QueryStatusColumn,
                context: {
                    adhocDetails: this,
                },
                sortable: false,
            },
            action: {
                label: "Query Results",
                shown: true,
                width: 110,
                priority: 9,
                entityColumn: true,
                columnRendererComponent: ActionColumn,
                context: {
                    adhocDetails: this,
                },
                sortable: false,
            },
            errorMsg: {
                label: "Message",
                shown: true,
                width: 450,
                priority: 10,
                columnRendererComponent: MessageColumn,
                context: {
                    adhocDetails: this,
                },
                sortable: false,
            },
            queriedData: {
                label: "queriedData",
                shown: false,
                width: 450,
                priority: 10,
                sortable: false,
            },
            deviceId: {
                label: "deviceId",
                shown: false,
                width: 450,
                priority: 10,
                sortable: false,
            },
        };

        this._renderer = new Renderer(this);
        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    get gameEditor() {
        return this.getGameEditor();
    }

    getGameEditor() {
        return this._gameEditor;
    }

    getDeviceEntity() {
        return this._deviceEntityDef;
    }

    isDirty() {
        return this._dirty;
    }

    async shutdown() {
        if (
            !_.isEmpty(this._adHocQueryResultEntitiesGen) &&
            this._adHocQueryResultEntitiesGen.shutdown
        ) {
            await this._adHocQueryResultEntitiesGen.shutdown();
        }
        this._unregisterListeners();
        return this._renderer.shutdown().then(
            () => {
                this._device = undefined;
                this._logger = undefined;
                this._steveIo = undefined;
                this._gameEditor = undefined;
                this._renderer = undefined;
                this._toggleMode = undefined;
                this._matchCount = undefined;
                this._devicesIdNameMap = undefined;
                this._preSelect = undefined;
                this._newCreated = undefined;
                this._justSaved = undefined;
                this._executionId = undefined;
                this._proxyAdHocQueryEntity = undefined;
                this._proxyExecutionEntity = undefined;
                this._adHocRun = undefined;
                this._lastRunSelected = undefined;
                this._adHocQueryExecutionEntityGen = undefined;
                this._adHocQueryResultEntitiesGen = undefined;
                this._noDevicesSelected = undefined;

                this._modalUserFeedback = undefined;
                this._deviceEntityDef = undefined;
                this._constructInstanceEntityDef = undefined;
                this._ControlUserEntityDef = undefined;
                this._controlUser = undefined;
                this._adHocQueryEntityDef = undefined;
                this._adHocQueryExecutionEntityDef = undefined;
                this._adHocQueryExecutionEntity = undefined;
                this._adHocQueriesMap = undefined;
                this._lastAdHocEntityId = undefined;
                this._lastAdHocResult = undefined;
                this._lastRunExecution = undefined;
                this._adHocQueryResultEntitiesDef = undefined;
                this._adHocQueryResultEntities = undefined;
                this._valuesToCopyToProxy = undefined;
                this._selectedResults = undefined;
                this.adHocQueryDropdownList = undefined;
                this._dirty = undefined;
                this._userSession = undefined;
                this._licenseRestriction = undefined;
                this._storageFactory = undefined;
                this._isCDSolutionAvailable = undefined;
                this._jobEntityDef = undefined;
                this._solutionDefinition = undefined;
                this._solutionName = undefined;
                this._results = undefined;
                this._gridKey = undefined;
            },
            (err) => {
                this._logger.warn(err, "AdHocQueryDetailsViewComponent.shutdown() error.");
            }
        );
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    getDevice(deviceId) {
        return this._deviceEntityDef.loadDevice(this.activeOrgId, deviceId, {name: true, id: true}); // "e0f88549-f98e-47d8-97bb-887bc78751b7"
    }

    getDeviceWithConfigs(deviceId) {
        return this._deviceEntityDef.loadDevice(this.activeOrgId, deviceId, {
            name: true,
            id: true,
            latestConfig: true,
            defaultConfig: true,
            stateData: true,
        }); // "e0f88549-f98e-47d8-97bb-887bc78751b7"
    }

    _getConfig(adHocResultEntity) {
        return Promise.resolve().then(() => {
            let deviceConfigFeed =
                adHocResultEntity.getQueriedData() || "No Configuration Available";
            deviceConfigFeed = deviceConfigFeed.replace(/(\/r)?\/n/g, "\n");
            let rawConfig = deviceConfigFeed;
            return Promise.resolve(rawConfig);
        });
    }

    async getCapturedConfig(adHocResultEntity) {
        if (!_.isEmpty(adHocResultEntity.getJobIds())) {
            return this._jobEntityDef.loadJobs(
                this.activeOrgId,
                {id: {$in: adHocResultEntity.getJobIds()}},
                {}
            );
        } else {
            return Promise.resolve("No configuration available");
        }
    }

    async searchClick(data) {
        this._proxyAdHocQueryEntity.setName(this.activeOrgId);
        if (this._proxyAdHocQueryEntity.isDirty()) {
            await this._proxyAdHocQueryEntity.update();
        }
        const {justRun} = data,
            selectedAdHocId = this._proxyAdHocQueryEntity.getId(),
            workTarget = {
                category: "entity",
                entityType: "Device",
                ids: this._selectedDevices,
                method: "multi",
            },
            workInput = {
                adHocQueryId: selectedAdHocId,
                initializeOnly: false,
                existingExecutionId: this._executionId,
            };

        this._justRunAdHoc = justRun;

        Object.assign(workInput, _.omit(data, "justRun"));

        const _progressCallBack = () => {
            if (!_.isEmpty(this._selectedResults)) {
                this._devicesInProxyRun = this._selectedResults;
            }
        };
        this._adHocRun = true;
        this._deviceEntityDef
            .runSearchWork(this.activeOrgId, workTarget, workInput, {}, _progressCallBack)
            .then((result) => {
                if (result.errorMsg) {
                    const err = {
                        errorCode: "WORK_ERROR",
                        errorMsg: result.errorMsg,
                        errorTitle: "Work Error",
                    };
                    this._modalUserFeedback.displayError(err);
                }
                this.resetWorkItems();
                this._results = result;
                this._matchCount = result.summary.deviceMatchedCount || 0;
                this._failuresCount = result.summary.deviceUnmatchedCount || 0;
            })
            .catch((err) => {
                this._logger.warn(err);
            });
    }

    async getAllResultEntities() {
        this._noDevicesSelected = false;
        if (_.isEmpty(this._selectedDevices)) {
            this._executionId = !_.isEmpty(this._adHocQueryExecutionEntity)
                ? this._adHocQueryExecutionEntity.getId()
                : null;
            if (this._executionId) {
                this._selectedResults = [];
                this._noDevicesSelected = true;
                return this._retrieveExecutionForGeneralUse(this._executionId);
            }
            return Promise.resolve();
        }

        const selectedAdHocId = this._proxyAdHocQueryEntity.getId(),
            workTarget = {
                category: "entity",
                entityType: "Device",
                ids: this._selectedDevices,
                method: "multi",
            },
            workInput = {
                regex: "",
                contentSource: "LATEST",
                adHocQueryId: selectedAdHocId,
                initializeOnly: true,
            };

        try {
            const result = await this._deviceEntityDef.runSearchWork(
                this.activeOrgId,
                workTarget,
                workInput,
                {}
            );
            if (result.status === "FAILED") {
                this._logger.warn(
                    result,
                    "AdhocQueryDetailsViewComponent.getAllResultEntities() error"
                );
                //return Promise.resolve();
            }
            const resultExecutionId = _.get(result, "summary.adHocQueryExecutionId", undefined);
            this._executionId = resultExecutionId;
            if (resultExecutionId) {
                return this._retrieveExecutionForGeneralUse(resultExecutionId);
            }
            return Promise.resolve();
        } catch (err) {
            this._logger.warn(err);
        } finally {
            this.emit("CheckAndEnableDisableRun");
        }
    }

    resetWorkItems() {
        this._results = undefined;
        this._setViewActionText("searchButton", "Run Query");
        this.emit("WorkCancel");
    }

    async _reestablishResultsFeed(query, secondCall = false) {
        await this._adHocQueryResultEntitiesGen._reestablishResultFeed(query);
        if (this._adHocQueryResultEntitiesGen.feed.status === "RE_INITIALIZING") {
            await this._adHocQueryResultEntitiesGen.whenFeedReady();
        }
        if (secondCall) {
            this._reestablishResultsFeed(query, false);
        }
        return Promise.resolve();
    }

    _onDirtyStateChanged(newVal) {
        this.emit("Dirty", newVal);

        let onBeforeUnloadFunc = () => {
            return this._modalUserFeedback
                .displayConfirmation("Would you like to Save or Discard your changes?", {
                    title: "Unsaved Changes",
                    confirmDetails: {
                        text: "Save",
                        type: "additive",
                    },
                    rejectDetails: {
                        text: "Discard",
                        type: "text",
                    },
                })
                .then(() => {
                    return this._modalUserFeedback.hideDisplayed();
                })
                .then(() => {
                    return this._renderer._saveUserData();
                })
                .catch((error) => {
                    // this.clearLastRunAdHocQuery();
                    if (!error.userRejected) {
                        this._logger.warn({error}, "Error in onBeforeUnloadFunc! Err:");
                    }
                });
        };

        if (newVal && this._renderer._selectedSavedQuery !== "  New Query") {
            this._gameEditor.setOnBeforeUnload(onBeforeUnloadFunc);
        } else {
            this._gameEditor.clearOnBeforeUnload();
        }
    }

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    get logger() {
        return this._logger;
    }

    get activeOrgId() {
        return this._userSession.activeOrganization.id;
    }

    get activeUserId() {
        return this._userSession._userEntity.id;
    }

    set conceptItems(newConceptItems) {
        this._conceptItems = _.cloneDeep(newConceptItems);
        return this;
    }

    get conceptItems() {
        return this._conceptItems;
    }

    get pagingFeed() {
        return this._adHocQueryResultEntitiesGen;
    }

    async whenModelIsReady(refreshfeed) {
        await this.loadAdHocQueries();
        await this.whenConceptItemsAreReady();
        await this._getAllCommandSets();

        if (refreshfeed || _.isEmpty(this.pagingFeed)) {
            await this.getAllResultEntities();
        }

        return Promise.resolve();
    }

    onUserSorted(sortData) {
        sortData = [].concat(sortData);
        let sort = {};

        sortData.forEach((sortData) => {
            if (!sortData || !sortData.sortColumn || !this.columnsResult[sortData.sortColumn]) {
                return;
            }
            let sortCriteria =
                this.columnsResult[sortData.sortColumn].valuePath ||
                this.columnsResult[sortData.sortColumn].path ||
                sortData.sortColumn;

            sort[sortCriteria] = sortData.sort === "asc" ? 1 : -1;
        });

        this._patchSorting(sort);

        this._adHocQueryResultEntitiesGen.setSort(sort);
    }

    _patchSorting(sorting) {
        // add second sorting order by name
        if (sorting && !sorting.deviceName && this.columnsResult.deviceName) {
            sorting.deviceName = 1;
        }
    }

    _setViewActionText(buttonValue, buttonText) {
        let buttonControl = _.get(
            this.gameEditor._viewContainerElem.nextElementSibling.lastElementChild.querySelectorAll(
                "button-control[value='" + buttonValue + "']"
            ),
            0
        );

        if (buttonControl) {
            buttonControl.innerHTML = buttonText;
        }
    }

    async getDeviceConfig(resultEntity /*, scope, searchMethod*/) {
        return Promise.resolve()
            .then(() => {
                const currentResultEntity = resultEntity;
                if (currentResultEntity) {
                    this._devicesIdNameMap[currentResultEntity.getDeviceId()] =
                        currentResultEntity.getDeviceName();
                } else {
                    console.log(
                        "Error retrieving AdHocQueryResult entity ID: ",
                        resultEntity.getId()
                    );
                }
                return Promise.resolve(currentResultEntity);
            })
            .then((currentResultEntity) => {
                if (!currentResultEntity) {
                    return "";
                }
                const adHocResultEntity = currentResultEntity;
                return this._getConfig(adHocResultEntity);
            });
    }

    getDeviceOptions() {
        return Promise.all(
            this._selectedDevices.map((deviceId) => {
                return this.getDevice(deviceId).then((device) => {
                    return {label: device.getName(), value: device.getId()};
                });
            })
        );
    }

    getDeviceOptionsForQueryView(deviceList) {
        let query = this._createQuery(deviceList);
        return this._deviceEntityDef.loadDevices(
            this.activeOrgId,
            query,
            {
                name: true,
                id: true,
                latestConfig: true,
                defaultConfig: true,
                stateData: true,
                detectedTypeBase: true,
            },
            {},
            false
        );
    }

    whenConceptItemsAreReady() {
        return this._constructInstanceEntityDef
            .loadConceptItemLabelValues(this.activeOrgId)
            .then((conceptItems) => {
                this.conceptItems = conceptItems.reduce((result, item) => {
                    result[item.value] = item;
                    return result;
                }, {});
                return Promise.resolve();
            })
            .then(() => {
                return this._constructInstanceEntityDef.loadRsiLabelValues(this.activeOrgId, {
                    "Config Modeling Only": {$ne: true},
                });
            })
            .then((rsiIds) => {
                this._rsiIds = rsiIds;
                this._rsiIdsMap = this._rsiIds.reduce((acc, item) => {
                    Object.assign(acc, {[item.value]: item});
                    return acc;
                }, {});
                return Promise.resolve();
            });
    }

    async loadAdHocQueries() {
        if (!this._controlUser) {
            this._controlUser = await this._ControlUserEntityDef.loadAscendControlUser(
                this.activeOrgId,
                this.activeUserId,
                {adHocQueries: true}
            );
        }

        // Review comment
        if (this._controlUser && typeof this._controlUser.loadRelatedAdHocQueries === "function") {
            this._relatedAdHocQueries = await this._controlUser.loadRelatedAdHocQueries({
                tid: this.activeOrgId,
            });
            this._relatedAdHocQueries = this._relatedAdHocQueries.filter(
                (i) => i.getSavedQuery() === true || i.getName() === this.activeOrgId
            );

            if (!this._adHocQueryEntity || this._adHocQueryEntity.isSynchronized()) {
                this._adHocQueryEntity = this._createNewAdHocQuery();
            }

            if (_.isEmpty(this._proxyAdHocQueryEntity)) {
                this._proxyAdHocQueryEntity = this._relatedAdHocQueries.find(
                    (entity) => entity.getName() === this.activeOrgId
                );
                if (_.isEmpty(this._proxyAdHocQueryEntity)) {
                    await this._getProxyEntity();
                } else {
                    this._proxyExecutionEntity = await this._loadRelatedExecution();
                    if (!_.isEmpty(this._proxyExecutionEntity)) {
                        await this._retrieveExecution(this._proxyExecutionEntity[0], true);
                        this._devicesInProxyRun = this._updateResultsFromProxyRun();
                    }
                }
            }

            this._relatedAdHocQueries = _.concat(this._relatedAdHocQueries, this._adHocQueryEntity);

            if (
                _.isEmpty(
                    this._relatedAdHocQueries.find(
                        (entity) => entity.getName() === this.activeOrgId
                    )
                )
            ) {
                this._relatedAdHocQueries = _.concat(
                    this._relatedAdHocQueries,
                    this._proxyAdHocQueryEntity
                );
            }

            this._relatedAdHocQueries.forEach((eachQuery) => {
                if (
                    eachQuery.getId() === this._lastAdHocEntityId &&
                    !this._newCreated &&
                    !this._justSaved
                ) {
                    this._preSelect = eachQuery.getName();
                    this._newCreated = false;
                }
                Object.assign(this._adHocQueriesMap, {
                    [eachQuery.getId() || "0"]: eachQuery,
                });
            });

            this._relatedAdHocQueries = _.uniq(this._relatedAdHocQueries);
            this.adHocQueryDropdownList = await this._createAdHocDropDownList(
                this._relatedAdHocQueries
            );

            return Promise.resolve(this._relatedAdHocQueries);
        }
    }

    updateAdHocDropdown() {
        return this.loadAdHocQueries();
    }

    async saveAdHocQuery(adHocQuery) {
        if (!adHocQuery.isSynchronized()) {
            adHocQuery.setSavedQuery(true);

            const adHocEntity = await adHocQuery.create();
            this._controlUser.addToAdHocQueriesRelationship(adHocEntity.getId());
            this._preSelect = adHocEntity.getId();
            this._newCreated = true;
            if (this._controlUser.isDirty()) {
                await this._controlUser.update();
            }
            return Promise.resolve(adHocEntity);
        } else {
            this._preSelect = adHocQuery.getId();
            if (adHocQuery.isDirty()) {
                adHocQuery.setSavedQuery(true);
                adHocQuery = await adHocQuery.update();
                return Promise.resolve(adHocQuery);
            }
            return Promise.resolve();
        }
    }

    async deleteAdHocQuery(adHocQueryId) {
        this._controlUser.removeFromAdHocQueriesRelationship(adHocQueryId);
        return this._adHocQueriesMap[adHocQueryId].delete().then(() => {
            delete this._adHocQueriesMap[adHocQueryId];
            return Promise.resolve();
        });
    }

    _setDirty(state) {
        this._dirty = state;
        this._onDirtyStateChanged(state);
        this._gameEditor._setDirty(state);
    }

    _createQuery(data) {
        return {
            $and: [{id: {$in: data}}],
        };
    }

    _hasAccessToCDA() {
        const hasPermission = !!_.get(this._userSession._userEntity, "authorizedActions").filter(
                (action) => action === "configDriftAndAuditAccess"
            ),
            hasLicense = this._licenseRestriction.checkLicense("CDA");

        if (hasPermission && hasLicense) {
            return true;
        }
        return false;
    }

    setMatchesAndFailureCount() {
        let devicesMatched = [],
            devicesUnmatched = [];
        if (this._adHocRun || this._lastRunSelected) {
            if (
                this._adHocQueryResultEntitiesGen._feed &&
                this._adHocQueryResultEntitiesGen._feed.getCache()
            ) {
                Object.values(this._adHocQueryResultEntitiesGen._feed.getCache()).forEach(
                    (eachEntity) => {
                        if (_.indexOf(this._selectedResults, eachEntity.getId()) > -1) {
                            if (
                                eachEntity &&
                                eachEntity.getMatchCount() &&
                                eachEntity.getMatchCount() > 0
                            ) {
                                devicesMatched.push(eachEntity.getDeviceId());
                            } else {
                                devicesUnmatched.push(eachEntity.getDeviceId());
                            }
                        }
                    }
                );
            }

            this._matchCount = devicesMatched.length;
            this._failuresCount = devicesUnmatched.length;
        }
    }

    // NEW Methods

    _createNewAdHocQuery() {
        return new this._adHocQueryEntityDef(this.activeOrgId);
    }

    async _retrieveExecution(adHocQueryExecutionId = this._executionId, isEntity = false) {
        if (!isEntity) {
            this._adHocQueryExecutionEntity =
                await this._adHocQueryExecutionEntityDef.retrieveAdHocQueryExecution(
                    this.activeOrgId,
                    adHocQueryExecutionId,
                    {status: true, lastRun: true}
                );
        } else {
            this._adHocQueryExecutionEntity = adHocQueryExecutionId;
        }
        this._proxyExecutionEntity = this._adHocQueryExecutionEntity;

        const fields = {
            id: true,
            status: true,
            deviceId: true,
            deviceDetectedTypeBase: true,
            deviceName: true,
            jobIds: true,
            matchCount: true,
            queriedData: true,
            errorMsg: true,
        };

        this._adHocQueryResultEntities = await this._adHocQueryExecutionEntity.loadRelatedResults(
            {},
            fields
        );

        // this._registerResultFeedEvents();

        return Promise.resolve();
    }

    async _retrieveExecutionForGeneralUse(adHocQueryExecutionId) {
        // Not make this call to retrieve if the execution entity exists
        this._adHocQueryExecutionEntityGen =
            await this._adHocQueryExecutionEntityDef.retrieveAdHocQueryExecution(
                this.activeOrgId,
                adHocQueryExecutionId,
                {status: true, lastRun: true}
            );
        const fields = {
            id: true,
            status: true,
            deviceId: true,
            deviceDetectedTypeBase: true,
            deviceName: true,
            jobIds: true,
            matchCount: true,
            queriedData: true,
            errorMsg: true,
        };
        let selectedResultEntities = [];

        if (!_.isEmpty(this._adHocQueryExecutionEntityGen)) {
            selectedResultEntities = await this._adHocQueryExecutionEntityGen.loadRelatedResults(
                {},
                fields
            );
        } else if (!_.isEmpty(this._adHocQueryExecutionEntity)) {
            selectedResultEntities = await this._adHocQueryExecutionEntity.loadRelatedResults(
                {},
                fields
            );
        }

        if (this._noDevicesSelected === false) {
            this._selectedResults = selectedResultEntities.map((i) => i.getId());
        }
        const query = this._createQuery(this._selectedResults);

        if (_.isEmpty(this._adHocQueryResultEntitiesGen)) {
            this._adHocQueryResultEntitiesGen = new PagingResultFeed({
                feedKey: this._gridKey + "_feed",
                activeOrgId: this.activeOrgId,
                entityDef: this._adHocQueryResultEntitiesDef,
                columnConfig: this.columnsResult,
                filter: query,
                sort: {deviceName: 1},
            });
            // this._registerResultFeedGenEvents();
            return this._adHocQueryResultEntitiesGen.whenFeedReady();
        } else {
            await this._reestablishResultsFeed(query, true);
            return Promise.resolve();
        }
    }

    async _loadRelatedExecution() {
        return await this._proxyAdHocQueryEntity.loadRelatedExecutions(
            {},
            {id: true, status: true, lastRun: true}
        );
    }

    async _getProxyEntity(valuesToCopy = {}) {
        this._proxyAdHocQueryEntity = await this._adHocQueryEntityDef.retrieveAdHocQueryByName(
            this.activeOrgId,
            this.activeOrgId,
            {}
        );

        if (_.isEmpty(this._proxyAdHocQueryEntity)) {
            this._proxyAdHocQueryEntity = new this._adHocQueryEntityDef(this.activeOrgId);
            this._proxyAdHocQueryEntity.setName(this.activeOrgId);
            this._proxyAdHocQueryEntity.setSavedQuery(false);
            if (!_.isEmpty(valuesToCopy)) {
                this._updateEntity(this._proxyAdHocQueryEntity, valuesToCopy, true);
            }
            this._proxyAdHocQueryEntity = await this._proxyAdHocQueryEntity.create();
        }

        this._controlUser.addToAdHocQueriesRelationship(this._proxyAdHocQueryEntity.getId());
        if (this._controlUser.isDirty()) {
            await this._controlUser.update();
        }
    }

    _updateResultsFromProxyRun() {
        if (this._adHocQueryResultEntities.length > 0) {
            return this._adHocQueryResultEntities.map((i) => i.getId());
        }
    }

    _updateEntity(entity, values, fromPristine = false) {
        if (fromPristine) {
            entity.setSource(values.source || "LATEST");
            entity.setFilter(values.filter || "NONE");

            if (values.filter === "NONE") {
                entity.setConceptItemId(values.conceptItemId || undefined);
            } else {
                entity.setConceptItemId(undefined);
            }
            if (values.filter === "SHOW") {
                entity.setShowCommands((values.show && values.show.split("\n")) || undefined);
            } else {
                entity.setShowCommands(undefined);
            }
            entity.setQuery(values.query || "");
        } else {
            entity.setSource(values.searchType || "LATEST");
            entity.setFilter(values.searchMethod || "NONE");

            if (values.searchMethod === "NONE") {
                entity.setConceptItemId(undefined);
                entity.setCommandSet(undefined);
                entity.setCommandSetResult(undefined);
                entity.setShowCommands(undefined);
            } else if (values.searchMethod === "COMMAND") {
                entity.setConceptItemId(undefined);
                entity.setShowCommands(undefined);
                entity.setCommandSet(values.commandSet || "all");

                let objCommandSetResult = {};
                if (values.commandSetResults === "all") {
                    objCommandSetResult = {
                        type: "all",
                    };
                } else if (values.commandSetResults === "basicMode") {
                    objCommandSetResult = {
                        type: "basicMode",
                    };
                } else if (
                    values.commandSetResults &&
                    values.commandSetResults.indexOf("rsi-id.") > -1
                ) {
                    const rsiId = values.commandSetResults.replace(/rsi-id./, "");
                    objCommandSetResult = {
                        type: "restSyncItems",
                        restSyncItemId: rsiId,
                    };
                } else if (
                    values.commandSetResults &&
                    values.commandSetResults.indexOf("show-command.") > -1
                ) {
                    const command = values.commandSetResults.replace(/show-command./, "");
                    objCommandSetResult = {
                        type: "cliCommands",
                        command: command,
                    };
                } else if (
                    values.commandSetResults &&
                    values.commandSetResults.indexOf("concept-item.") > -1
                ) {
                    const conceptItemId = values.commandSetResults.replace(/concept-item./, "");
                    objCommandSetResult = {
                        type: "conceptItems",
                        conceptItemId: conceptItemId,
                    };
                } else if (
                    values.commandSetResults &&
                    values.commandSetResults.indexOf("get-url.") > -1
                ) {
                    const getURLVal = values.commandSetResults.replace(/get-url./, "");
                    objCommandSetResult = {
                        type: "getUrls",
                        getUrl: getURLVal,
                    };
                }

                entity.setCommandSetResult(objCommandSetResult);
            } else if (values.searchMethod === "SECTION") {
                entity.setConceptItemId(undefined);
                entity.setCommandSet(undefined);
                entity.setCommandSetResult(undefined);
                entity.setShowCommands(undefined);
                entity.setCommandSetResult(undefined);
                if (values.section.indexOf("concept-item.") > -1) {
                    entity.setConceptItemId(values.section.replace(/concept-item./, ""));
                } else if (values.section.indexOf("rsi-id.") > -1) {
                    entity.setRsiId(values.section.replace(/rsi-id./, ""));
                }
            } else if (values.searchMethod === "SHOW") {
                entity.setConceptItemId(undefined);
                entity.setCommandSet(undefined);
                entity.setCommandSetResult(undefined);
                entity.setShowCommands((values.show && values.show.split("\n")) || undefined);
            }

            entity.setQuery(values.searchField || "");
        }
        entity.setUserId(_.get(this._userSession, "user.id"));

        if (
            !_.isEmpty(entity._pendingPatches) &&
            entity._pendingPatches.length === 1 &&
            _.get(entity._pendingPatches, "0.path", "") === "/userId"
        ) {
            entity.update();
        }

        return entity;
    }

    async _cloneEntity(entity) {
        if (
            !_.isEmpty(this._proxyExecutionEntity) &&
            _.isArray(this._proxyExecutionEntity) &&
            this._proxyExecutionEntity.length > 0
        ) {
            this._proxyExecutionEntity = this._proxyExecutionEntity[0];
        }
        this._proxyAdHocQueryEntity = await entity.clone(this.activeOrgId);

        this._controlUser.addToAdHocQueriesRelationship(this._proxyAdHocQueryEntity.getId());

        await this._proxyAdHocQueryEntity.addToExecutionsRelationship(
            this._proxyExecutionEntity.getId()
        );
        await entity.clearExecutionsRelationship();

        this._proxyAdHocQueryEntity.setSavedQuery(false);
        entity.setSavedQuery(true);
        if (entity.isDirty()) {
            await entity.update();
        }
        if (this._proxyAdHocQueryEntity.isDirty()) {
            await this._proxyAdHocQueryEntity.update();
        }
        if (this._controlUser.isDirty()) {
            await this._controlUser.update();
        }
        return Promise.resolve();
    }

    async _createAdHocDropDownList(adHoclist) {
        let arr = await adHoclist.map(async (adHocEntity) => {
            let disabled = false;
            let adHocLabel = adHocEntity.getName();
            if (_.isUndefined(adHocLabel) || adHocLabel === "") {
                adHocLabel = "  New Query";
            } else if (adHocLabel === this.activeOrgId) {
                adHocLabel = " Last Run";
                const execution = await this._proxyAdHocQueryEntity.loadRelatedExecutions(
                    {},
                    {id: true, status: true, lastRun: true, completedOn: true, startedOn: true}
                );
                if (_.isEmpty(execution)) {
                    disabled = true;
                } else {
                    adHocLabel += ` [${this._toLocaleString(
                        execution[0].getCompletedOn() || execution[0].getStartedOn()
                    )}]`;
                }
            }
            return {
                label: adHocLabel,
                value: adHocEntity.getId() || 0,
                disabled,
            };
        });
        arr.sort((a, b) => (a.label > b.label ? 1 : -1));

        arr.splice(
            0,
            0,
            arr.splice(
                arr.findIndex((i) => i.label === "  New Query"),
                1
            )[0]
        );
        arr.splice(
            1,
            0,
            arr.splice(
                arr.findIndex((i) => i.label.indexOf(" Last Run") > -1),
                1
            )[0]
        );

        return arr;
    }

    _toLocaleString(val) {
        let d = new Date(val);
        if (Object.prototype.toString.call(d) === "[object Date]" && !isNaN(d.getTime())) {
            return d.toLocaleDateString() + " " + d.toLocaleTimeString();
        } else {
            return "";
        }
    }

    async _getAllCommandSets() {
        const fields = {};

        const showDisabledVal = [true];
        if (this._showDisabledCommands) {
            showDisabledVal.push(false);
        }
        const query = {
            $and: [
                {
                    enabled: {$in: showDisabledVal},
                },
            ],
        };

        if (_.isEmpty(this._commandSetsFeed)) {
            this._commandSetsFeed = this._CommandSetEntityDef.startCommandSetsFeed(
                this.activeOrgId,
                query,
                fields,
                {},
                {skip: 0, limit: 200}
            );
        } else {
            this._commandSetsFeed.reestablishFeed(this.activeOrgId, query, fields, {});
            this._feedUpdated();
        }
        return this._commandSetsFeed.whenInitialized();
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = AdhocQueryDetailsViewComponent;

AdhocQueryDetailsViewComponent.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.userSession",
    "$teve.licenseRestriction",
    "$teve.ui.userFeedback",
    "$teve.solutionsManager",
    "$teve.storageFactory",
    "$teve.io",
    "$teve.entities.Device",
    "$teve.entities.ConstructInstance",
    "$teve.entities.Job",
    "$teve.entities.ControlUser",
    "$teve.entities.AdHocQuery",
    "$teve.entities.AdHocQueryExecution",
    "$teve.entities.AdHocQueryResult",
    "$teve.entities.CommandSet",
];

AdhocQueryDetailsViewComponent.$displayDetails = {
    type: "View",
    name: "Ad Hoc Query",
    icon: "devicemanager.network_discovery_view",
    shown: true,
    title: "Details",
    order: 1,
};
